export default {
    driver_performance_events_info_caseId: "ID del Caso",
    driver_performance_events_info_status: "Estado",
    driver_performance_events_info_next_step: "Siguiente Paso",
    driver_performance_events_info_created: "Creado",
    driver_performance_events_info_driver: "Conductor",
    driver_performance_events_info_coach: "Supervisor",
    driver_performance_events_info_evaluation: "Evaluación",
    driver_performance_events_info_complete: "Completo",
    driver_performance_events_info_no_case_info: "No hay información del caso disponible.",
    driver_performance_events_info_unassigned: "Sin Asignar",
    driver_performance_events_change_coach: "Cambiar Supervisor",
};